module.exports = __webpack_public_path__ + "img/star.baec4d3a.svg";